module.exports = __webpack_public_path__ + "img/vn.7e902ada.svg";